import { render, staticRenderFns } from "./personaleventform.vue?vue&type=template&id=074ab60a&"
import script from "./personaleventform.vue?vue&type=script&lang=js&"
export * from "./personaleventform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports